var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    { staticClass: "help-popover-host" },
    [
      _c(
        "span",
        {
          ref: "trigger",
          staticClass: "help-trigger",
          attrs: { tabindex: "0" },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.handleClick.apply(null, arguments)
            },
            keydown: [
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                $event.stopPropagation()
                return _vm.handleClick.apply(null, arguments)
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "space", 32, $event.key, [
                    " ",
                    "Spacebar"
                  ])
                )
                  return null
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.handleClick.apply(null, arguments)
              }
            ],
            mouseenter: _vm.handleMouseEnter,
            mouseleave: _vm.handleMouseLeave
          }
        },
        [
          _vm._t("trigger", function() {
            return [
              _c("i", { staticClass: "fa fa-question-circle text-info small" })
            ]
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm.isOpen
        ? [
            _c("div", {
              staticClass: "popover-backdrop",
              on: { click: _vm.close }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "popoverContainer",
                staticClass: "help-popover-container",
                style: _vm.containerStyle,
                on: {
                  mouseenter: _vm.handlePopoverMouseEnter,
                  mouseleave: _vm.handlePopoverMouseLeave
                }
              },
              [
                _c(
                  "transition",
                  { attrs: { name: "popover-fade", appear: "" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "popover help-popover",
                        class: { "wide-popover": _vm.wide },
                        attrs: { role: "tooltip", id: _vm.popoverId }
                      },
                      [
                        !_vm.wide
                          ? _c("div", {
                              staticClass: "arrow",
                              class: _vm.arrowClass
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "popover-body",
                            class: _vm.wide ? "p-4" : "p-2"
                          },
                          [
                            _vm.showCloseButton
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "help-popover-close",
                                    attrs: {
                                      "aria-label": _vm.closeButtonText
                                    },
                                    on: { click: _vm.close }
                                  },
                                  [_c("i", { staticClass: "fa fa-times" })]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._t("default", function() {
                              return [
                                _c("div", {
                                  staticClass: "help-popover-content",
                                  domProps: { innerHTML: _vm._s(_vm.helpText) }
                                })
                              ]
                            })
                          ],
                          2
                        )
                      ]
                    )
                  ]
                )
              ],
              1
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }